export default "./src/client/components/auth/login/open-web/spid-button/img/spid-idp-intesaid.svg?24148f8b2522999be58f7cfc4940cba2";